import React, {Component} from "react";
import {connect} from "react-redux";

import {Button, Menu as DropdownMenu, message, Popover, Statistic, Tabs, Tooltip} from "antd";

import {MinMaxModal} from "./MinMaxModal";
import {ArchiveIterationModal} from "./ArchiveIterationModal"
import {selectProject} from "../../actions/actions";
import axios from "../../api";
import api from "../../api";
import * as Auth from "../../AuthService";
import {
	checkAnyOfPermissions,
	createScopeLink,
	downloadExcel,
	getProjectId,
	labelMapper,
	openLinkInNewTab,
} from "../../helpers";
import {MaterialsSearch} from "../../pages/MaterialsSearch";
import {ActionsMenu} from "../helpers/ActionsMenu";
import {ScenarioLink} from "../helpers/cards/MaterialBlock";
import {HelpModal} from "../helpers/modals/HelpModal";
import {InfoModal} from "../helpers/modals/InfoModal";
import {StandardTable} from "../helpers/TablePanel";
import {Archive} from "../../variants";

import "../helpers.css";
import {PageTitle} from "../helpers/PageTitle";

const {TabPane} = Tabs;

export class MinMaxIterationPanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			iterations: [],
			openModal: false,
			openInfoModal: false,
			scopes: [],
			ex_report_templates: [],
			iteration: {
				constants: {},
			},
			hasRights: false,
			loading: false,
			newPagination: {
				current: 1,
				pageSize: 10,
			},
			total: 0,
			_filters: {},
		};
	}
	componentDidMount() {
		this.checkAdminPermission();
		const p = window.location.search;
		const params = new URLSearchParams(p);
		const from = params.get("search");
		if (from) {
			this.setState({activeKey: "2"});
		}
	}

	checkAdminPermission = () => {
		checkAnyOfPermissions([
			"senior-user",
			"approve-user",
			"insurance-admin",
			"admin",
			"superadmin",
			"material-analyst",
			"inventory-analyst",
			"dm-maintenance",
			"dm-inventory",
			"stock-owner",
		])
			.then(() => this.setState({hasRights: true}))
			.catch(() => this.setState({hasRights: false}));
	};

	render() {
		const project_id = getProjectId(this.props.location);

		const setActiveKey = key => {
			this.setState({activeKey: key});
		};

		return (
			<div style={{padding: 24}}>
				<PageTitle title="Scenarios" />
				<Tabs defaultActiveKey={"1"} activeKey={this.state.activeKey} onTabClick={setActiveKey}>
					<TabPane tab={"My Scenarios"} key={"1"}>
						<IterationsList
							props={this.props}
							projectId={project_id}
							user={true}
							shouldUpdate={this.state.shouldUpdate}
							update={() => this.setState({shouldUpdate: !this.state.shouldUpdate})}
						/>
					</TabPane>
					<TabPane tab={"All Scenarios"} key={"3"}>
						<IterationsList
							props={this.props}
							projectId={project_id}
							user={false}
							shouldUpdate={this.state.shouldUpdate}
							update={() => this.setState({shouldUpdate: !this.state.shouldUpdate})}
						/>
					</TabPane>
					{Archive.enabled && (
                        <TabPane tab={"Archived scenarios"} key={"4"}>
                            <ArchiveIterationsList
                                props={this.props}
                                projectId={project_id}
                                user={false}
                                shouldUpdate={this.state.shouldUpdate}
                                update={() => this.setState({shouldUpdate: !this.state.shouldUpdate})}
                            />
                        </TabPane>
                    )}
					{this.state.hasRights && (
						<TabPane tab={"Materials"} key={"2"}>
							<MaterialsSearch projectId={project_id} />
						</TabPane>
					)}
				</Tabs>
			</div>
		);
	}
}

export class IterationsList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			iterations: [],
			openModal: false,
			openInfoModal: false,
			openArchiveModal: false,
			scopes: [],
			allScopes: [],
			users: [],
			scenarioNames: [],
			ex_report_templates: [],
			iteration: {
				constants: {},
			},
			hasRights: false,
			loading: false,
			newPagination: {
				current: 1,
				pageSize: 10,
			},
			total: 0,
			_filters: {},
		};
	}

	calcTypeLabels = {
		naive: "Statistical Forecasting (naive)",
		bom: "BOM forecast",
		combined: "Combined (first naive, then bom)",
		never: "Never",
		month: "Every Month",
		quarter: "Every 3 Months",
		halfYear: "Every Half a Year",
		year: "Every Year",
		all: "All",
		corrective: "Corrective",
		planned: "Planned",
		true: "Yes",
		false: "No",
		limit: "Limit spikes",
		exclude: "Remove spikes",
	};

	yesNoFilters = [
		{text: "Yes", value: true},
		{text: "No", value: false},
	];

	reviewStatusFilters = [
		{text: "Calculating", value: "calculating"},
		{text: "Ready for Review", value: "ready_for_review"},
		{text: "In Review", value: "in_review"},
		{text: "Partially approved", value: "partially_approved"},
		{text: "Approved", value: "approved"},
	];

	reviewStatusLabels = {
		calculating: "Calculating",
		ready_for_review: "Ready for Review",
		in_review: "In Review",
		partially_approved: "Partially approved",
		approved: "Approved",
	};

	renderReviewStatus = (reviewStatus, row) => {
		const label = this.reviewStatusLabels[reviewStatus] || "N/A";
		const approved = row.approved_materials_count ?? 0;
		const total = row.materials_total ?? 0;
		const buckets = row.buckets_count ?? 0;
		const statusClass = reviewStatus ? `review-status-${reviewStatus}` : "";
		return (
			<Tooltip
				title={
					<div>
						<div>
							Approved materials: {approved}/{total}
						</div>
						<div>Buckets: {buckets}</div>
					</div>
				}>
				<span className={statusClass}>{label}</span>
			</Tooltip>
		);
	};

	getFilterScopes(projectId) {
		api.get(
			`/projects/${projectId}/iterations/scopes?user_specific=${this.props.user}&filter_by_iterations=true`,
			Auth.createConfig(),
		).then(json => this.setState({scopes: json.data.items}));
	}

	getFilterUsers(projectId) {
		if (this.props.user) {
			return;
		}
		api.get(
			`/projects/${projectId}/iterations/filter/options?field_name=user`,
			Auth.createConfig(),
		).then(json => this.setState({users: json.data}));
	}

	getFilterScenarioNames(projectId) {
		api.get(
			`/projects/${projectId}/iterations/filter/options?field_name=iteration_name&user_specific=${this.props.user}`,
			Auth.createConfig(),
		).then(json => this.setState({scenarioNames: json.data}));
	}

	getAllProjectScopes(projectId) {
		api.get(`/projects/${projectId}/iterations/scopes`, Auth.createConfig()).then(json =>
			this.setState({allScopes: json.data.items}),
		);
	}

	getIterations(newPagination = this.state.newPagination, _filters = this.state._filters) {
		this.setState({loading: true});
		const project_id = this.props.projectId;
		const pagination = {
			current: newPagination.current,
			size: newPagination.pageSize,
		};

		if (newPagination.pageSize !== this.state.newPagination.pageSize) {
			pagination.current = 1;
		}
		const data = {
			pagination,
			_filters,
		};
		this.setState({projectId: project_id});
		axios
			.post(`/projects/${project_id}/iterations?user_specific=${this.props.user}`, data, Auth.createConfig())
			.then(json =>
				this.setState({
					iterations: json.data.iterations,
					projectId: project_id,
					newPagination: newPagination,
					_filters: _filters,
					total: json.data.total,
				}),
			)
			.finally(() => this.setState({loading: false}));
	}

	onChange = (newPagination, _filters, _sorter) => {
		this.getIterations(newPagination, _filters);
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.shouldUpdate !== this.props.shouldUpdate) {
			this.getIterations();
			this.getFilterScenarioNames(this.props.projectId);
		}

		if (prevProps.projectId !== this.props.projectId) {
			this.getIterations();
			this.getFilterScopes(this.props.projectId);
			this.getFilterUsers(this.props.projectId);
			this.getFilterScenarioNames(this.props.projectId);
			this.getAllProjectScopes(this.props.projectId);
		}
	}

	componentDidMount() {
		this.getIterations();
		this.checkAdminPermission();
		const p = window.location.search;
		const params = new URLSearchParams(p);
		const from = params.get("search");
		if (from) {
			this.setState({activeKey: "2"});
		}
		const project_id = this.props.projectId;

		this.getFilterScopes(project_id);
		this.getFilterUsers(project_id);
		this.getFilterScenarioNames(project_id);
		this.getAllProjectScopes(project_id);

		api.get(`/projects/${project_id}/exception-reporting/templates`).then(json =>
			this.setState({ex_report_templates: json.data.items}),
		);
	}

	checkAdminPermission = () => {
		checkAnyOfPermissions([
			"senior-user",
			"approve-user",
			"insurance-admin",
			"admin",
			"superadmin",
			"material-analyst",
			"inventory-analyst",
			"dm-maintenance",
			"dm-inventory",
			"stock-owner",
		])
			.then(() => this.setState({hasRights: true}))
			.catch(() => this.setState({hasRights: false}));
	};

	createActionsMenu(iteration) {
		const project_id = this.props.projectId;
		return (
			<DropdownMenu>
				<DropdownMenu.Item
					className="url-link"
					onClick={() =>
						openLinkInNewTab(`/projects/${project_id}/min-max/scenarios/${iteration._id}/overview`)
					}>
					Open
				</DropdownMenu.Item>
				{this.state.hasRights && !iteration.has_approval_buckets && (
					<DropdownMenu.Item className="url-link" onClick={() => this.rerunIteration(iteration._id)}>
						Re-run iteration
					</DropdownMenu.Item>
				)}
				<DropdownMenu.Item
					className="url-link"
					onClick={() => this.exportIteration(iteration._id, iteration.iteration_name)}>
					Export
				</DropdownMenu.Item>
				{this.state.hasRights && iteration.status === "scenarioProcessing" && (
					<DropdownMenu.Item className="url-link" onClick={() => this.stopIteration(iteration._id)}>
						Stop
					</DropdownMenu.Item>
				)}
				{this.state.hasRights && !iteration.has_approval_buckets && (
					<DropdownMenu.Item className="url-link" onClick={() => this.deleteIteration(iteration._id)}>
						Delete
					</DropdownMenu.Item>
				)}
				{Archive.enabled && this.state.hasRights && iteration.status === "scenarioFinished" && (
					<DropdownMenu.Item
						className="url-link"
						onClick={() => this.setState({openArchiveModal: true, iteration: iteration, padding: 5})}>
						Archive
					</DropdownMenu.Item>
				)}
			</DropdownMenu>
		);
	}

	getProgress = item => {
		const valueStyle = {fontSize: 16};
		if (Object.keys(item).includes("processed")) {
			if (item.processed && item.total) {
				return <Statistic valueStyle={valueStyle} value={item.processed} suffix={`/ ${item.total}`} />;
			}
		}
		return (
			<Statistic
				className="text-center"
				valueStyle={valueStyle}
				value={(item.results && item.results.items_affected) || 0}
			/>
		);
	};

	getColumns = () => {
		const valueStyle = {fontSize: 16};
		return [
			{
				title: "Scenario Name",
				dataIndex: "iteration_name",
				key: "iteration_name",
				align: "left",
				filterSearch: true,
				filters: this.state.scenarioNames.map(name => ({
					value: name,
					text: name,
				})),
				render: (name, scenario) => <ScenarioLink name={name} id={scenario._id} />,
			},
			{
				title: "User",
				dataIndex: "user",
				key: "user",
				align: "left",
				width: 200,
				...(this.props.user
					? {}
					: {
							filters: this.state.users.map(user => ({
								value: user,
								text: user,
							})),
					  }),
				render: user => user || "NA",
			},
			{
				title: "Scenario Scope",
				dataIndex: "scope",
				key: "scope",
				filters: this.state.scopes.map(v => ({
					value: v._id,
					text: v.name || v.label,
				})),
				render: scope => (
					<div
						className={"beautiful-link"}
						onClick={() => {
							const project_id = this.props.projectId;
							window.open(createScopeLink(project_id, scope._id));
						}}>
						{scope && (scope.name || scope.label)}
					</div>
				),
			},
			{
				title: "Materials Analyzed",
				dataIndex: "analyzed",
				key: "analyzed",
				align: "center",
				render: (name, item) => this.getProgress(item),
			},
			{
				title: "Status",
				dataIndex: "status",
				key: "status",
				align: "center",
				filters: Object.keys(this.statusLabels).map(status => ({
					value: status,
					text: this.statusLabels[status],
				})),
				render: (status, row) => (
					<Popover content={row["results"]["error"]}>
						<div className={status}>{this.statusLabels[status]}</div>
					</Popover>
				),
			},
			{
				title: "Review Status",
				dataIndex: "review_status",
				key: "review_status",
				align: "center",
				filters: this.reviewStatusFilters,
				render: (reviewStatus, row) => this.renderReviewStatus(reviewStatus, row),
			},
			{
				title: "ML",
				dataIndex: "ml",
				key: "ml",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{item["constants"]["ml"] ? "Yes" : "No"}</div>,
			},
			{
				title: "Stocking Calculator",
				dataIndex: "constants",
				key: "use_stocking_calculator",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{item["constants"]["use_stocking_calculator"] ? "Yes" : "No"}</div>,
			},
			{
				title: "Forecast",
				dataIndex: "forecastingMethod",
				key: "forecastingMethod",
				align: "center",
				filters: ["naive", "bom", "combined"].map(value => ({
					value,
					text: this.calcTypeLabels[value],
				})),
				render: (ml, item) => <div>{labelMapper(item["constants"]["forecastingMethod"])}</div>,
			},
			{
				title: "Transactions",
				dataIndex: "use_pm",
				key: "use_pm",
				align: "center",
				filters: ["all", "planned", "corrective"].map(value => ({
					value,
					text: this.calcTypeLabels[value],
				})),
				render: (ml, item) => <div>{this.calcTypeLabels[item["constants"]["use_pm"]]}</div>,
			},
			{
				title: "Smoothing",
				dataIndex: "use_demand_smoothing",
				key: "use_demand_smoothing",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{this.calcTypeLabels[item["constants"]["use_demand_smoothing"]]}</div>,
			},
			{
				title: "Add. Info",
				dataIndex: "info",
				key: "info",
				width: 100,
				align: "center",
				render: (name, item) => (
					<p style={{paddingTop: 5}}>
						<Button onClick={() => this.setState({openInfoModal: true, iteration: item, padding: 5})}>
							?
						</Button>
					</p>
				),
			},
			{
				title: "Actions",
				dataIndex: "actions",
				key: "actions",
				align: "center",
				width: 100,
				render: (name, item) => <ActionsMenu actions={this.createActionsMenu(item)} />,
			},
		];
	};

	deleteIteration(iterationId) {
		const project_id = this.props.projectId;
		axios.get(`/projects/${project_id}/iterations/${iterationId}/delete`, Auth.createConfig()).then(json => {
			alert(json.data);
			this.props.update();
		});
	}

	onFinishArchiveIteration = (values, iterationId) => {
		const project_id = this.props.projectId;
		axios.post(
		    `/projects/${project_id}/iterations/${iterationId}/archive`,
		    {add_info: values?.add_info,},
		    Auth.createConfig()
		)
		.then(json => {
			message.info("Scenario successfully archived");
			this.props.update();
			this.state.openArchiveModal = false;
		});
	}

	stopIteration(iterationId) {
		const project_id = this.props.projectId;
		axios.get(`/projects/${project_id}/iteration/${iterationId}/stop`, Auth.createConfig()).then(json => {
			message.info("Trying to stop Iteration");
			this.props.update();
		});
	}

	rerunIteration(iterationId) {
		const project_id = this.props.projectId;
		message.info("Start re-calculating the scenario");
		axios
			.get(`/projects/${project_id}/iteration/${iterationId}/run`, Auth.createConfig())
			.then(() => {
				this.props.update();
			})
			.catch(() => {});
	}

	exportIteration = (iteration_id, iteration_name) => {
		message.info("Starting the export of " + iteration_name);
		const project_id = this.props.projectId;
		const config = Auth.createConfig();
		config["responseType"] = "blob";
		axios
			.get(`/projects/${project_id}/iterations/${iteration_id}/min-max/export`, config)
			.then(json => {
				downloadExcel(json.data, `Proposed MIN-MAX ${iteration_name}.xlsx`);
			})
			.catch(error => {
				console.log(error);
			});
	};

	parseDataSource = () =>
		this.state.iterations.map(iteration => ({
			key: iteration._id,
			_id: iteration._id,
			scope: iteration.scope,
			user: iteration.user,
			iteration_name: iteration.iteration_name,
			constants: iteration.constants,
			results: iteration.results,
			start: iteration.results.start,
			created: iteration.results.created,
			finished: iteration.results.finished,
			status: iteration.results.status,
			processed: iteration.processed,
			total: iteration.total,
			has_approval_buckets: iteration.has_approval_buckets,
			report_id: iteration.report_id,
			review_status: iteration.review_status,
			approved_materials_count: iteration.approved_materials_count,
			materials_total: iteration.materials_total,
			buckets_count: iteration.buckets_count,
		}));

	statusLabels = {
		scenarioFinished: "Finished",
		scenarioProcessing: "Performing the calculations",
		scenarioError: "Error while performing calculations",
		scenarioStopped: "Stopped by user",
		scenarioInQueue: "Waiting in the Queue",
	};
	render() {
		return (
			<div>
				<Button className="float-right" style={{marginLeft: 10}} onClick={() => this.getIterations()}>
					Update Statuses
				</Button>
				<Button
					className="float-right"
					style={{marginLeft: 10}}
					onClick={() => this.setState({helpModal: true})}>
					?
				</Button>
				{this.state.hasRights && (
					<Button className="float-right" onClick={() => this.setState({openModal: true})}>
						Add New Scenario
					</Button>
				)}
				<StandardTable
					data={this.parseDataSource()}
					scroll={800}
					loading={this.state.loading}
					total={this.state.total}
					onChange={this.onChange}
					pageSize={this.state.newPagination.pageSize}
					currentPage={this.state.newPagination.current}
					tableProps={{}}
					tableSize={"small"}
					columns={this.getColumns()}
				/>
				<MinMaxModal
					modalState={this.state.openModal}
					scopes={this.state.allScopes}
					ex_report_templates={this.state.ex_report_templates}
					calcTypeLabels={this.calcTypeLabels}
					projectId={this.props.projectId}
					runCalcs={this.rerunIteration}
					closeModal={_id => {
						this.setState({openModal: false});
						this.props.update();
					}}
				/>
				<HelpModal
					isModalVisible={this.state.helpModal}
					setModalVisible={value => this.setState({helpModal: value})}
				/>
				<InfoModal
					isModalVisible={this.state.openInfoModal}
					iteration={this.state.iteration}
					setModalVisible={value => this.setState({openInfoModal: value})}
					projectId={this.props.projectId}
				/>
				{Archive.enabled && (
                    <ArchiveIterationModal
                        isModalVisible={this.state.openArchiveModal}
                        iteration={this.state.iteration}
                        setIsModalVisible={value => this.setState({openArchiveModal: value})}
                        onFinish={this.onFinishArchiveIteration}
                    />
                )}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	inventoryInfo: state.inventoryInfo,
	selectedProject: state.selectedProject,
});

export default connect(mapStateToProps, {
	selectProject,
})(MinMaxIterationPanel);

export class ArchiveIterationsList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			iterations: [],
			openModal: false,
			openInfoModal: false,
			scopes: [],
			archivedBy: [],
			scenarioNames: [],
			ex_report_templates: [],
			iteration: {
				constants: {},
			},
			hasRights: false,
			loading: false,
			newPagination: {
				current: 1,
				pageSize: 10,
			},
			total: 0,
			_filters: {},
		};
	}

	calcTypeLabels = {
		naive: "Statistical Forecasting (naive)",
		bom: "BOM forecast",
		combined: "Combined (first naive, then bom)",
		never: "Never",
		month: "Every Month",
		quarter: "Every 3 Months",
		halfYear: "Every Half a Year",
		year: "Every Year",
		all: "All",
		corrective: "Corrective",
		planned: "Planned",
		true: "Yes",
		false: "No",
		limit: "Limit spikes",
		exclude: "Remove spikes",
	};

	yesNoFilters = [
		{text: "Yes", value: true},
		{text: "No", value: false},
	];

	getFilterScopes(projectId) {
		api.get(
			`/projects/${projectId}/iterations/scopes?archived=true&filter_by_iterations=true`,
			Auth.createConfig(),
		).then(json => this.setState({scopes: json.data.items}));
	}

	getFilterArchivedBy(projectId) {
		api.get(
			`/projects/${projectId}/iterations/filter/options?field_name=last_change_by&archived=true`,
			Auth.createConfig(),
		).then(json => this.setState({archivedBy: json.data}));
	}

	getFilterScenarioNames(projectId) {
		api.get(
			`/projects/${projectId}/iterations/filter/options?field_name=iteration_name&archived=true`,
			Auth.createConfig(),
		).then(json => this.setState({scenarioNames: json.data}));
	}

	getIterations(newPagination = this.state.newPagination, _filters = this.state._filters) {
		this.setState({loading: true});
		const project_id = this.props.projectId;
		const pagination = {
			current: newPagination.current,
			size: newPagination.pageSize,
		};

		if (newPagination.pageSize !== this.state.newPagination.pageSize) {
			pagination.current = 1;
		}
		const data = {
			pagination,
			_filters,
		};
		this.setState({projectId: project_id});
		axios
			.post(
			    `/projects/${project_id}/iterations?user_specific=${this.props.user}&archived=True`,
			    data,
			    Auth.createConfig()
			)
			.then(json =>
				this.setState({
					iterations: json.data.iterations,
					projectId: project_id,
					newPagination: newPagination,
					_filters: _filters,
					total: json.data.total,
				}),
			)
			.finally(() => this.setState({loading: false}));
	}

	onChange = (newPagination, _filters, _sorter) => {
		this.getIterations(newPagination, _filters);
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.shouldUpdate !== this.props.shouldUpdate) {
			this.getIterations();
			this.getFilterScopes(this.props.projectId);
			this.getFilterArchivedBy(this.props.projectId);
			this.getFilterScenarioNames(this.props.projectId);
		}

		if (prevProps.projectId !== this.props.projectId) {
			const resetPagination = {current: 1, pageSize: 10};
			const resetFilters = {};
			this.setState({newPagination: resetPagination, _filters: resetFilters}, () => {
				this.getIterations(resetPagination, resetFilters);
				this.getFilterScopes(this.props.projectId);
				this.getFilterArchivedBy(this.props.projectId);
				this.getFilterScenarioNames(this.props.projectId);
			});
		}
	}

	componentDidMount() {
		this.getIterations();
		this.checkAdminPermission();
		const p = window.location.search;
		const params = new URLSearchParams(p);
		const from = params.get("search");
		if (from) {
			this.setState({activeKey: "2"});
		}
		const project_id = this.props.projectId;
		this.getFilterScopes(project_id);
		this.getFilterArchivedBy(project_id);
		this.getFilterScenarioNames(project_id);
		api.get(`/projects/${project_id}/exception-reporting/templates`).then(json =>
			this.setState({ex_report_templates: json.data.items}),
		);
	}

	checkAdminPermission = () => {
		checkAnyOfPermissions([
			"senior-user",
			"approve-user",
			"insurance-admin",
			"admin",
			"superadmin",
			"material-analyst",
			"inventory-analyst",
			"dm-maintenance",
			"dm-inventory",
			"stock-owner",
		])
			.then(() => this.setState({hasRights: true}))
			.catch(() => this.setState({hasRights: false}));
	};

	createActionsMenu(iteration) {
		const project_id = this.props.projectId;
		return (
			<DropdownMenu>
				<DropdownMenu.Item
					className="url-link"
					onClick={() =>
						openLinkInNewTab(
							`/projects/${project_id}/min-max/scenarios/${iteration._id}/overview?archived=true`,
						)
					}>
					Open
				</DropdownMenu.Item>
				<DropdownMenu.Item
					className="url-link"
					onClick={() => this.exportIteration(iteration._id, iteration.iteration_name)}>
					Export
				</DropdownMenu.Item>
				{this.state.hasRights && !iteration.has_approval_buckets && (
					<DropdownMenu.Item className="url-link" onClick={() => this.deleteIteration(iteration._id)}>
						Delete
					</DropdownMenu.Item>
				)}
			</DropdownMenu>
		);
	}

	getProgress = item => {
		const valueStyle = {fontSize: 16};
		if (Object.keys(item).includes("processed")) {
			if (item.processed && item.total) {
				return <Statistic valueStyle={valueStyle} value={item.processed} suffix={`/ ${item.total}`} />;
			}
		}
		return (
			<Statistic
				className="text-center"
				valueStyle={valueStyle}
				value={(item.results && item.results.items_affected) || 0}
			/>
		);
	};

	getColumns = () => {
		const valueStyle = {fontSize: 16};
		return [
			{
				title: "Scenario Name",
				dataIndex: "iteration_name",
				key: "iteration_name",
				align: "left",
				filterSearch: true,
				filters: this.state.scenarioNames.map(name => ({
					value: name,
					text: name,
				})),
				render: (name, scenario) => <ScenarioLink name={name} id={scenario._id} archived={true} />,
			},
			{
				title: "Archived by",
				dataIndex: "last_change_by",
				key: "last_change_by",
				align: "left",
				width: 100,
				filters: this.state.archivedBy.map(user => ({
					value: user,
					text: user,
				})),
				render: last_change_by => last_change_by || "NA",
			},
			{
				title: "Archive date",
				dataIndex: "last_change_date",
				key: "last_change_date",
				align: "left",
				width: 100,
				render: last_change_date => last_change_date || "NA",
			},
			{
				title: "Scenario Scope",
				dataIndex: "scope",
				key: "scope",
				filters: this.state.scopes.map(v => ({
					value: v._id,
					text: v.name || v.label,
				})),
				render: scope => (
					<div
						className={"beautiful-link"}
						onClick={() => {
							const project_id = this.props.projectId;
							window.open(createScopeLink(project_id, scope._id));
						}}>
						{scope && (scope.name || scope.label)}
					</div>
				),
			},
			{
				title: "Materials Analyzed",
				dataIndex: "analyzed",
				key: "analyzed",
				align: "center",
				render: (name, item) => this.getProgress(item),
			},
			{
				title: "ML",
				dataIndex: "ml",
				key: "ml",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{item["constants"]["ml"] ? "Yes" : "No"}</div>,
			},
			{
				title: "Stocking Calculator",
				dataIndex: "constants",
				key: "use_stocking_calculator",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{item["constants"]["use_stocking_calculator"] ? "Yes" : "No"}</div>,
			},
			{
				title: "Forecast",
				dataIndex: "forecastingMethod",
				key: "forecastingMethod",
				align: "center",
				filters: ["naive", "bom", "combined"].map(value => ({
					value,
					text: this.calcTypeLabels[value],
				})),
				render: (ml, item) => <div>{labelMapper(item["constants"]["forecastingMethod"])}</div>,
			},
			{
				title: "Transactions",
				dataIndex: "use_pm",
				key: "use_pm",
				align: "center",
				filters: ["all", "planned", "corrective"].map(value => ({
					value,
					text: this.calcTypeLabels[value],
				})),
				render: (ml, item) => <div>{this.calcTypeLabels[item["constants"]["use_pm"]]}</div>,
			},
			{
				title: "Smoothing",
				dataIndex: "use_demand_smoothing",
				key: "use_demand_smoothing",
				align: "center",
				filters: this.yesNoFilters,
				render: (ml, item) => <div>{this.calcTypeLabels[item["constants"]["use_demand_smoothing"]]}</div>,
			},
			{
				title: "Add. Info",
				dataIndex: "info",
				key: "info",
				width: 100,
				align: "center",
				render: (name, item) => (
					<p style={{paddingTop: 5}}>
						<Button onClick={() => this.setState({openInfoModal: true, iteration: item, padding: 5})}>
							?
						</Button>
					</p>
				),
			},
			{
				title: "Actions",
				dataIndex: "actions",
				key: "actions",
				align: "center",
				width: 100,
				render: (name, item) => <ActionsMenu actions={this.createActionsMenu(item)} />,
			},
		];
	};

	deleteIteration(iterationId) {
		const project_id = this.props.projectId;
		axios.get(
		`/projects/${project_id}/iterations/${iterationId}/delete?archived=True`, Auth.createConfig()
		).then(json => {
			alert(json.data);
			this.props.update();
		});
	}

	exportIteration = (iteration_id, iteration_name) => {
		message.info("Starting the export of " + iteration_name);
		const project_id = this.props.projectId;
		const config = Auth.createConfig();
		config["responseType"] = "blob";
		axios
			.get(`/projects/${project_id}/iterations/${iteration_id}/min-max/export?archived=True`, config)
			.then(json => {
				downloadExcel(json.data, `Proposed MIN-MAX ${iteration_name}.xlsx`);
			})
			.catch(error => {
				console.log(error);
			});
	};

	parseDataSource = () =>
		this.state.iterations.map(iteration => ({
			key: iteration._id,
			_id: iteration._id,
			scope: iteration.scope,
			last_change_by: iteration.last_change_by,
			last_change_date: iteration.last_change_date,
			iteration_name: iteration.iteration_name,
			constants: iteration.constants,
			results: iteration.results,
			start: iteration.results.start,
			created: iteration.results.created,
			finished: iteration.results.finished,
			processed: iteration.processed,
			total: iteration.total,
			has_approval_buckets: iteration.has_approval_buckets,
			add_info: iteration?.add_info,
			report_id: iteration.report_id,
		}));

	render() {
		return (
			<div>
				<Button
					className="float-right"
					style={{marginLeft: 10}}
					onClick={() => this.setState({helpModal: true})}>
					?
				</Button>
				<StandardTable
					data={this.parseDataSource()}
					scroll={800}
					loading={this.state.loading}
					total={this.state.total}
					onChange={this.onChange}
					pageSize={this.state.newPagination.pageSize}
					currentPage={this.state.newPagination.current}
					tableProps={{}}
					tableSize={"small"}
					columns={this.getColumns()}
				/>
				<HelpModal
					isModalVisible={this.state.helpModal}
					setModalVisible={value => this.setState({helpModal: value})}
				/>
				<InfoModal
					isModalVisible={this.state.openInfoModal}
					iteration={this.state.iteration}
					setModalVisible={value => this.setState({openInfoModal: value})}
					archived
					projectId={this.props.projectId}
				/>
			</div>
		);
	}
}